<template lang="pug">
div
  v-card(flat)
    v-card-title Parking
    keep-alive
      validation-observer(
        ref="o09",
        v-slot="{ invalid }",
        :persist="true",
        vid="o09"
      )
        v-container
          v-row
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 How much onsite (at event location) parking will be available?
              validation-provider(
                rules="required",
                v-slot="{ errors }",
                immediate
              )
                v-radio-group(
                  v-model="SEA_IsParkingAvailable",
                  row,
                  dense,
                  :disabled="disabled"
                )
                  v-radio(
                    v-for="option in isParkingAvailable",
                    :key="option",
                    :label="option",
                    :value="option"
                  )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 Is there offsite (not at event location) parking for the event?
              validation-provider(
                rules="required",
                v-slot="{ errors }",
                immediate
              )
                v-radio-group(
                  v-model="SEA_ParkingOffsite",
                  row,
                  dense,
                  :disabled="disabled"
                )
                  v-radio(
                    v-for="option in yesNoString",
                    :key="option",
                    :label="option",
                    :value="option"
                  )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row(v-if="SEA_ParkingOffsite === 'Yes'")
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 Where is the offsite parking location?
              v-text-field.pb-3.pl-3(
                outlined,
                hide-details,
                dense,
                v-model="SEA_ParkingOffsiteDesc",
                :disabled="disabled"
              )
          v-row(v-if="SEA_ParkingOffsite === 'Yes'")
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 Will you provide shuttle transportation to the event site?
              v-radio-group(
                v-model="SEA_ParkingShuttleOpt",
                row,
                dense,
                :disabled="disabled"
              )
                v-radio(
                  v-for="option in yesNoString",
                  :key="option",
                  :label="option",
                  :value="option"
                )
          v-row
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 Parking Plan
              p.pb-0.pl-8.text--secondary How will event attendees arrive? Describe the public transportation options, parking options, shuttle (if applicable) and how the public will become aware of these options.
              v-textarea.pb-3.pl-3(
                outlined,
                hide-details,
                dense,
                v-model="SEA_ParkingDesc",
                :disabled="disabled"
              )
</template>


<script>
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import store from "../store";

export default {
  components: {
    //
  },
  store,
  computed: {
    ...mapState({
      data: (state) => state.data,
      yesNoString: (state) => state.yesNoString,
    }),
    ...mapFields([
      "data.SEA_IsParkingAvailable",
      "data.SEA_ParkingOffsite",
      "data.SEA_ParkingOffsiteDesc",
      "data.SEA_ParkingShuttleOpt",
      "data.SEA_ParkingDesc",
      "data.disabled",
    ]),
  },
  data: () => ({
    isParkingAvailable: [
      "Ample",
      "Limited",
      "None",
    ],
  }),
  methods: {
    //
  },
};
</script>